// Library Imports
import React, { useState } from "react";
import { Link, useLocation } from "@tanstack/react-router";
// Functions, Helpers, Utils, and Hooks
import useWindowWidth from "../../../hooks/useWindowWidth";
// Components
import AnimatedNavLink from "./dependents/components/AnimatedNavLink";
import ThemeToggle from "./dependents/components/ThemeToggle";
// CSS
import "./dependents/css/navbar.scss";
// Assets and Images
import logo from "../../../assets/images/logo/logo.webp";

const Navbar: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const windowWidth = useWindowWidth();
  const location = useLocation();

  const listOfUrlsToUseGlassmorphicVariant = [""];
  let variant: string;

  if (listOfUrlsToUseGlassmorphicVariant.includes(location.pathname)) {
    variant = "glassmorphic";
  } else {
    variant = "default";
  }

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav
      className={`navbar ${variant}-navbar full-flex padding-left-80 padding-right-80 padding-top-40 padding-bottom-40`}
    >
      <div className="navbar-brand">
        <Link to="/">
          <img src={logo} alt="Footer Logo" className="navbar-logo" />
        </Link>
        {windowWidth <= 768 && (
          <button className="navbar-toggle" onClick={toggleMenu}>
            <span className="navbar-toggle-icon">&#9776;</span>
          </button>
        )}
      </div>
      <div
        className={`navbar-menu${isOpen ? " navbar-menu-open" : ""} display-flex align-items-center justify-content-right gap-20`}
      >
        <ul className="space-around-flex align-items-center">
          <li>
            <AnimatedNavLink linkText="Home" url="/" />
          </li>

          <li>
            <AnimatedNavLink linkText="Menu" url="/menu" />
          </li>

          <li>
            <AnimatedNavLink linkText="Location & Contact" url="/location-and-contact" />
          </li>
        </ul>

        <ThemeToggle linkText="Toggle Theme" />
      </div>
    </nav>
  );
};

export default Navbar;
